export default {
  path: '/leave',
  name: 'Leave',
  component: () => import('../views/layouts/Leave.layout.vue'),
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: 'test',
      name: 'LeaveTest',
      component: () => import('../views/pages/Leave/LeaveTest.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'list/:guid',
      name: 'LeaveUser',
      component: () => import('../views/pages/Leave/LeaveUser.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'empleave/:guid',
      name: 'LeaveHistory',
      component: () => import('../views/pages/Leave/LeaveHistory.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'relaxstat/:guid',
      name: 'ReportLeaveRelaxStat',
      component: () =>
        import('../views/pages/Leave/Report/LeaveReportRelaxStat.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'approve',
      name: 'LeaveApprove',
      component: () => import('../views/layouts/Blank.layout.vue'),
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: '/',
          name: 'LeaveApproveList',
          component: () => import('../views/pages/Leave/LeaveApprove.page.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'emp/:guid/order/:leaveOrderId/timeline',
          name: 'LeaveApproveTimeline',
          component: () =>
            import(
              '../views/pages/Leave/LeaveApprove/LeaveApproveTimeline.page.vue'
            ),
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: 'pending/:guid',
      name: 'LeavePending',
      component: () => import('../views/layouts/Blank.layout.vue'),
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: '/',
          name: 'LeavePendingList',
          component: () => import('../views/pages/Leave/LeavePending.page.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'order/:leaveOrderId/timeline',
          name: 'LeavePendingTimeline',
          component: () =>
            import(
              '../views/pages/Leave/LeavePending/LeavePendingTimeline.page.vue'
            ),
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: 'form/sick/:guid/:leaveOrderId?',
      name: 'LeaveFormSick',
      component: () => import('../views/pages/Leave/LeaveFormSick.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'form/buss/:guid/:leaveOrderId?',
      name: 'LeaveFormBuss',
      component: () => import('../views/pages/Leave/LeaveFormBuss.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'form/graduate/:guid/:leaveOrderId?',
      name: 'LeaveFormGraduate',
      component: () =>
        import('../views/pages/Leave/LeaveFormGraduate.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'form/cremation/:guid/:leaveOrderId?',
      name: 'LeaveFormCremation',
      component: () =>
        import('../views/pages/Leave/LeaveFormCremation.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'form/deliver/:guid/:leaveOrderId?',
      name: 'LeaveFormDeliver',
      component: () => import('../views/pages/Leave/LeaveFormDeliver.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'form/relax/:guid/:leaveOrderId?',
      name: 'LeaveFormRelax',
      component: () => import('../views/pages/Leave/LeaveFormRelax.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'form/dharma/:guid/:leaveOrderId?',
      name: 'LeaveFormDharma',
      component: () => import('../views/pages/Leave/LeaveFormDharma.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'form/ordain/:guid/:leaveOrderId?',
      name: 'LeaveFormOrdain',
      component: () => import('../views/pages/Leave/LeaveFormOrdain.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'form/hutch/:guid/:leaveOrderId?',
      name: 'LeaveFormHutch',
      component: () => import('../views/pages/Leave/LeaveFormHutch.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'form/soldier/:guid/:leaveOrderId?',
      name: 'LeaveFormSoldier',
      component: () => import('../views/pages/Leave/LeaveFormSoldier.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'form/study/:guid/:leaveOrderId?',
      name: 'LeaveFormStudy',
      component: () => import('../views/pages/Leave/LeaveFormStudy.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'form/married/:guid/:leaveOrderId?',
      name: 'LeaveFormMarried',
      component: () => import('../views/pages/Leave/LeaveFormMarried.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'form/wife/:guid/:leaveOrderId?',
      name: 'LeaveFormWife',
      component: () => import('../views/pages/Leave/LeaveFormWife.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'form/cancel/:guid/:leaveOrderId?',
      name: 'LeaveFormCancel',
      component: () => import('../views/pages/Leave/LeaveFormCancel.page.vue'),
      meta: {
        requiresAuth: true
      }
    }
  ]
}
